import React, { useState, useEffect } from 'react';

const StatusBar = () => {
  const [time, setTime] = useState('');

  // 更新时间
  useEffect(() => {
    const updateTime = () => {
      const now = new Date();
      let hours = now.getHours();
      const minutes = now.getMinutes();
      const ampm = hours >= 12 ? 'PM' : 'AM';
      
      hours = hours % 12;
      hours = hours ? hours : 12; // 12小时制
      
      const formattedTime = `${hours}:${minutes < 10 ? '0' + minutes : minutes} ${ampm}`;
      setTime(formattedTime);
    };

    // 初始化时间
    updateTime();
    
    // 每分钟更新一次时间
    const interval = setInterval(updateTime, 60000);
    
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="sticky top-0 h-11 bg-[#f9f9f9] flex justify-between items-center px-5 text-sm font-semibold z-50">
      <div>{time}</div>
      <div className="flex space-x-2">
        <i className="fa-solid fa-signal"></i>
        <i className="fa-solid fa-wifi"></i>
        <i className="fa-solid fa-battery-full"></i>
      </div>
    </div>
  );
};

export default StatusBar;